import relativeTime from 'dayjs/plugin/relativeTime';
import { isNil } from 'lodash';

import dayjs from '../dayjs';

dayjs.extend(relativeTime);

/** Duration defines duration in milliseconds, the default time unit in Javascript. */
export const enum Duration {
  MILLISECOND = 1,
  SECOND = 1000 * MILLISECOND,
  MINUTE = 60 * SECOND,
  HOUR = 60 * MINUTE,
}

/**
 * A delay promise
 * @param {Number} ms delay miliseconds
 */
export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Format time
 * @param {Date} date
 */
export function ymdhms(date: null): null;
export function ymdhms(date: undefined): undefined;
export function ymdhms(date: string | Date | number): string;
export function ymdhms(date?: string | Date | number | null): string | null | undefined;
export function ymdhms(date?: string | Date | number | null) {
  if (isNil(date)) return date;
  if (typeof date === 'string' && isNaN(Date.parse(date))) return date;
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * Format time
 * @param {Date} date
 */
export function ymd(date: null): null;
export function ymd(date: undefined): undefined;
export function ymd(date: string | Date | number): string;
export function ymd(date?: string | Date | number | null): string | null | undefined;
export function ymd(date?: string | Date | number | null) {
  if (isNil(date)) return date;
  if (typeof date === 'string' && isNaN(Date.parse(date))) return date;
  return dayjs(date).format('YYYY-MM-DD');
}

/**
 * Format time
 * @param {Date} Date
 */

export function ym(date: null): null;
export function ym(date: undefined): undefined;
export function ym(date: string | Date | number): string;
export function ym(date?: string | Date | number | null): string | null | undefined;
export function ym(date?: string | Date | number | null) {
  if (isNil(date)) return date;
  if (typeof date === 'string' && isNaN(Date.parse(date))) return date;
  return dayjs(date).format('YYYY-MM');
}

/**
 * Format time
 * @param {Date} Date
 */

export function isoString(date: null): null;
export function isoString(date: undefined): undefined;
export function isoString(date: string | Date | number): string;
export function isoString(date?: string | Date | number | null): string | null | undefined;
export function isoString(date?: string | Date | number | null) {
  if (isNil(date)) return date;
  if (typeof date === 'string' && isNaN(Date.parse(date))) return date;
  return dayjs(date).toISOString();
}

export const friendlyMonths = (days: number) => {
  const years = Math.floor(days / 365);
  const months = Math.floor((days % 365) / 30);

  let result = '';
  if (years) result += `${years}年`;
  if (months) result += `${months}个月`;
  return result;
};

export const toFriendlyMonthsSpan = (
  start: string | Date | number,
  end: string | Date | number = new Date()
) => {
  if (isNil(start) || isNil(end)) return '';
  const days = dayjs(end).diff(dayjs(start), 'days');
  return friendlyMonths(days);
};

export const toFriendly = (d: string | Date | number) => {
  if (d === '--') return '--';
  return dayjs(d).fromNow();
};

export const toMediaDuration = (totalSeconds: number): string => {
  if (totalSeconds < 0) {
    return `00:00:00`;
  }
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const tryToDate = (date: string | Date | number | undefined) => {
  if (isNil(date)) return undefined;
  return new Date(date);
};

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
